import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import {
  APIOrchidDriveDirectory,
  APIOrchidDriveFile,
  DriveEntryError,
} from "../types";

class BatchEntryOpsError extends Error {
  errorByEntryId: Array<{ entry_id: string; error: DriveEntryError }>;

  constructor(
    errorByEntryId: Array<{ entry_id: string; error: DriveEntryError }>,
  ) {
    super("orchid drive entry changes failed");
    this.name = "DriveEntryKeysUnavailableError";
    this.errorByEntryId = errorByEntryId;
  }
}

type MoveArgs = {
  entryId: string;
  nameEncrypted?: string;
  parentDirectoryId?: string | null;
};

type DeleteArgs = {
  entryId: string;
};

export async function batchEntryOps(
  entryMoves: MoveArgs[],
  entryDeletes: DeleteArgs[],
): Promise<{
  fileEntryChanges: APIOrchidDriveFile[];
  directoryEntryChanges: APIOrchidDriveDirectory[];
}> {
  const response = await fetchOrchidAPI(`/api/drive_data/batch_ops/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      entry_moves: entryMoves.map((e) => {
        return {
          entry_id: e.entryId,
          name_encrypted: e.nameEncrypted,
          set_parent_directory_id: e.parentDirectoryId !== undefined,
          parent_directory_id: e.parentDirectoryId,
        };
      }),
      entry_deletes: entryDeletes.map((e) => {
        return { entry_id: e.entryId };
      }),
    }),
  });
  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  const result = await response.json();

  if (result.error_by_entry_id.length > 0) {
    throw new BatchEntryOpsError(result.error_by_entry_id);
  }

  return {
    fileEntryChanges: result.file_entry_changes,
    directoryEntryChanges: result.directory_entry_changes,
  };
}
